export const caseValueTypes = [
  {
    label: 'Variable',
    value: 'variable',
  },
  {
    label: 'Custom Text',
    value: 'customText',
  },
];

export const caseValueWithFormFieldTypes = [
  {
    label: 'Variable',
    value: 'variable',
  },
  {
    label: 'Custom Text',
    value: 'customText',
  },
  {
    label: 'Form Field',
    value: 'formField',
  },
];
